import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ReportIrrigationPlanner = ({
  irrigationData,
  precipitationData,
  dateData,
}) => {
  const generateLabels = () => {
    const labels = [];
    const startingDate = new Date(dateData);
    startingDate.setDate(startingDate.getDate() + 1);
    for (let i = 0; i < 7; i++) {
      const date = new Date(startingDate);
      date.setDate(startingDate.getDate() + i);
      const month = date.toLocaleString("default", { month: "short" });
      const day = date.getDate();
      labels.push(`${month} ${day}`);
    }
    return labels;
  };

  const labels = generateLabels();

  const data = {
    labels,
    datasets: [
      {
        label: "Irrigation",
        data: irrigationData,
        backgroundColor: "rgba(179, 226, 196, 0.5)",
        borderWidth: 1,
      },
      {
        label: "Precipitation",
        data: precipitationData,
        backgroundColor: "rgba(223, 240, 255, 0.9)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 40,
          boxHeight: 20,
          font: {
            size: 13,
          },
        },
      },
    },
    layout: {
      padding: {
        bottom: 20,
      },
    },
    scales: {
      y: {
        display: true,
        beginAtZero: true,
      },
      x: {
        grid: {
          display: true,
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default ReportIrrigationPlanner;
